module.exports = __webpack_public_path__ + "img/screen-5.9b780ac7.jpg";